import {Component, Input} from '@angular/core';
import {Section} from '@shared/services/hygraph/hygraph.models';
import { ScrollHelper } from '@app/@shared/utils/scroll-helper';

@Component({
  selector: 'app-hygraph-navigation',
  templateUrl: './hygraph-navigation.component.html',
  styleUrls: ['./hygraph-navigation.component.scss']
})
export class HygraphNavigationComponent {
  @Input() sections: Section[];
  @Input() includeTableOfContent: boolean;
  @Input() createAnchorHref: (id: string) => string;

  public onClick(event: MouseEvent,  elementId: string): void {
    event.preventDefault();
    ScrollHelper.scrollToSection(elementId)
  }
}
